export default "__VITE_ASSET__B2s0C1s6__"